import { lazy } from 'react'

export const EmailVariant4 = lazy(() => import('./EmailVariant4'))
